export const elmoExperimentResourceNames = {
  default: 'GOPS_smarthelp',
  pcc: 'GOPS_smarthelp_pcc',
  icfPrompt: 'GOPS_smarthelp_icf_prompt',
  stepUpVenice: 'GOPS_smarthelp_venice_step_up',
  kmSearch: 'GOPS_smarthelp_km_search',
  pendingDisputes: 'GOPS_smarthelp_pending_disputes_alert',
};

export const elmoTreatmentNames = {
  kmSearchEnabled: 'Trmt_GOPS_Helpcenter_KM_Search_Enable',
  pendingDisputesNotification: 'Trmt_GOPS_Helpcenter_Pending_Disputes_Alert_Show',
  treatmentForIcfDefault: 'Trmt_GOPS_Helpcenter_ICF_Experiment_2',
  treatmentforIcfTop: 'Trmt_GOPS_Helpcenter_ICF_PROMPT_Experiment_1',
  treatmentForIcfDown: 'Trmt_GOPS_Helpcenter_ICF_PROMPT_Experiment_2',
};

export const isPartOfElmoExpTreatment = (elmoTreatments, treatmentName) => (Array.isArray(elmoTreatments) && elmoTreatments.indexOf(treatmentName) >= 0);
